module.exports = __webpack_public_path__ + "img/sld_ch_10_t1_green.1c10e3d4.svg";